module.exports = __webpack_public_path__ + "img/PropietarioDatos.95802b38.svg";